// eslint-disable-next-line import/prefer-default-export
export const createRenderCompleteEventKey = (accountGUID) => `/${accountGUID}/account/render_complete`;
